<template>
    <v-dialog width="1000px" :value="value" @input="toggleModal" persistent scrollable>
        <v-card class="kbLight">
            <v-toolbar class="kbGold" dark text flat>
                <div class="text-h6">{{selectedEvent ? $t('general.editEvent') : $t('general.newEvent') }}</div>
                <v-spacer/>
                <v-btn icon @click="toggleModal(false)">
                    <v-icon>clear</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text v-if="loadingEvent">
                <v-row align="center" justify="center" style="min-height: 30vh">
                    <v-progress-circular indeterminate
                                         color="kbGold">
                    </v-progress-circular>
                </v-row>
            </v-card-text>

            <v-card-text v-else>
                <v-container class="pa-0" fluid>
                    <v-form v-model="valid" ref="newEditEventForm" lazy-validation>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field :label="$t('general.title')"
                                              color="kbDarkBlueText"
                                              :rules="[rules.required]"
                                              v-model="event.title">
                                </v-text-field>
                            </v-col>

                            <v-col cols="12">
                                <v-text-field :label="$t('general.shortDescription')"
                                              color="kbDarkBlueText"
                                              v-model="event.shortDescription"/>
                            </v-col>

                            <v-col cols="12">
                                <v-tabs v-model="descriptionTab"
                                        background-color="transparent">
                                    <v-tab>Normal</v-tab>
                                    <v-tab>HTML</v-tab>
                                </v-tabs>

                                <v-tabs-items v-model="descriptionTab" class="transparent">
                                    <v-tab-item>
                                        <v-card flat
                                                class="transparent">
                                            <quill-editor v-model="event.longDescription"/>
                                        </v-card>
                                    </v-tab-item>

                                    <v-tab-item>
                                        <v-card flat
                                                class="transparent">
                                            <pre v-highlightjs="event.longDescription"
                                                 style="height: fit-content; line-height: 0;">
                                                  <code @blur="blurEmailHtmlHandler"
                                                        class="xml"
                                                        contenteditable="true"
                                                        style="display: block; min-height: 200px; resize: vertical; overflow-y: auto; text-align: left; line-height: 1.5; white-space: pre;"
                                                        :rules="[rules.required]">
                                                  </code>
                                                </pre>
                                        </v-card>
                                    </v-tab-item>
                                </v-tabs-items>
                            </v-col>

                            <v-col cols="12">
                                <v-text-field v-model="event.note"
                                              color="kbDarkBlueText"
                                              :label="$t('general.note')">
                                </v-text-field>
                            </v-col>

                            <v-col cols="12">
                                <quill-editor v-model="event.emailNote"
                                              :options="{placeholder: $t('general.insertNoteToSendInConfirmationEmail')}"/>
                            </v-col>

                            <v-col cols="12">
                                <v-checkbox v-model="event.hasEventUrl"
                                            hide-details
                                            :label="$t('general.isAnOnlineEvent')">
                                </v-checkbox>
                            </v-col>

                            <v-col cols="12" v-if="event.hasEventUrl">
                                <v-text-field v-model="event.eventUrl"
                                              :label="$t('general.eventUrl')"
                                              :rules="[rules.required]">
                                </v-text-field>
                            </v-col>
                            <!---Tipo --->
                            <v-col cols="12" sm="12">
                                <v-autocomplete
                                :items="eventCategories"
                                  multiple
                                  color="kbDarkBlueText"
                                  :label="$t('general.categories')"
                                  item-text="name"
                                  item-value="id"
                                  v-model="event.categories">
                                </v-autocomplete>
                            </v-col>
                            <!---Categoria --->
                            <!-- <v-col cols="12" sm="6">
                                <v-autocomplete :label="$t('general.category')"
                                          color="kbDarkBlueText"
                                          multiple
                                          v-model="event.category"
                                          item-color="kbDarkBlueText"
                                          :item-text="'category' ? 'category': 'label'"
                                          item-value="label"
                                          return-object
                                          :items="categories">
                                </v-autocomplete>
                            </v-col> -->
                            <v-col>
                            <v-autocomplete
                              :items="eventPreferences"
                              color="kbDarkBlueText"
                              :label="$t('general.preferences')"
                              item-text="label"
                              item-value="id"
                              v-model="event.preferences"
                              multiple
                            >
                            </v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <DateTimePicker v-model="event.starts"
                                                :min="minDate()"
                                                @click:clear="event.ends = ''"
                                                :label="$t('general.startDate')">
                                </DateTimePicker>
                            </v-col>

                            <v-col cols="12" sm="6">
                                <DateTimePicker v-model="event.ends"
                                                :min="minDateUntil(event.starts)"
                                                :label="$t('general.finishDate')"
                                                :disabled="!event.starts">
                                </DateTimePicker>
                            </v-col>

                            <v-col cols="12" class="text-h6 kbDarkBlueText--text">
                              <h3 class="pt-5">{{ $t('general.infoPlace') }}</h3>

                              <p class="kbGray--text pt-3"
                              style="font-size: 15px; cursor: pointer; width: max-content"
                              @click="showPlacesSelector">
                                {{ placesSelector ? $t('general.cantFindPlace') : $t('general.canFindPlace') }}
                              </p>
                            </v-col>
                            <v-col v-if="placesSelector" cols="12">
                              <v-select
                                  :items="places"
                                  color="kbDarkBlueText"
                                  :label="$t('general.places')"
                                  item-text="name"
                                  item-value="id"
                                  v-model="event.placeId">
                              </v-select>
                            </v-col>

                            <v-col v-if="!placesSelector" cols="12">
                                <v-text-field :label="$t('general.place')"
                                              color="kbDarkBlueText"
                                              v-model="event.place"/>
                            </v-col>

                            <v-col v-if="!placesSelector" cols="12" sm="6">
                                <v-text-field :label="$t('general.latitude')"
                                              color="kbDarkBlueText"
                                              v-model="event.location.coordinates[0]"/>
                            </v-col>

                            <v-col v-if="!placesSelector" cols="12" sm="6">
                                <v-text-field :label="$t('general.longitude')"
                                              color="kbDarkBlueText"
                                              v-model="event.location.coordinates[1]"/>
                            </v-col>

                            <v-col cols="12" md="6">
                                <v-text-field :label="$t('general.organizer')"
                                              color="kbDarkBlueText"
                                              v-model="event.planner"/>
                            </v-col>

                            <v-col cols="12" md="6">
                              <v-autocomplete :label="$t('general.timeZone')"
                                              :items="timeZones"
                                              item-text="label"
                                              return-object
                                              v-model="event.timeZone"
                              ></v-autocomplete>
                            </v-col>

                            <v-col cols="12" sm="6">
                                <v-text-field :label="`${$t('general.eventRating')} (1-5)`"
                                              color="kbDarkBlueText"
                                              v-model.number="event.eventRating"
                                              prepend-icon="mdi-star-half-full"
                                              type="number"
                                />
                            </v-col>

                            <v-col cols="12" sm="6">
                                <v-text-field :label="`${$t('general.priceRating')} (1-4)`"
                                              color="kbDarkBlueText"
                                              v-model.number="event.priceRating"
                                              prepend-icon="mdi-currency-usd"
                                              type="number"
                                />
                            </v-col>

                            <v-col cols="12">
                                <v-text-field :label="`${$t('general.businessFee')} (%)`"
                                              color="kbDarkBlueText"
                                              v-model.number="event.businessFee"
                                              prepend-icon="mdi-currency-usd"
                                              type="number"
                                />
                            </v-col>

                            <v-col cols="12">
                              <VenueTagsAutocomplete
                                v-model="event.tags"
                              />
                            </v-col>

                            <v-col cols="12">
                                <v-switch :label="$t('general.limitRegisterByIdentificationDocument')"
                                          color="kbBlue"
                                          v-model="event.limitByDocument">
                                </v-switch>
                            </v-col>

                            <v-col cols="12">
                                <SocialNetworksPicker v-model="event.socialLinks"/>
                            </v-col>

                            <v-col cols="12">
                                <ContactsPicker v-model="event.contacts"/>
                            </v-col>

                            <v-col cols="12">
                                <ImagePicker button-color="kbGold" v-model="event.coverImage" :title="$t('general.cover')"/>
                            </v-col>

                            <v-col cols="12">
                                <ImagePicker button-color="kbGold" v-model="event.images" :title="$tc('general.pictures',1)"/>
                            </v-col>

                            <v-col cols="12">
                                <TicketPicker
                                  :currency="event.currency"
                                  :eventEndsAt="event.ends"
                                  :eventStartsAt="event.starts"
                                  :isEditingEvent="selectedEvent !== ''"
                                  @updateCurrency="event.currency = $event"
                                  v-model="event.tickets"
                                />
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer/>
                <v-btn class="mr-2" color="red" outlined @click="cancelNew">{{ $t('general.cancel') }}</v-btn>
                <v-btn color="kbGold" dark @click="submit" :loading="loading">{{(selectedEvent) ? $t('general.editEvent') : $t('general.createEvent')}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import ContactsPicker from '@/pages/App/Events/dialogs/ContactsPicker.vue'
import DateTimePicker from '@/components/ui/DateTimePicker'
import VenueTagsAutocomplete from '@/components/ui/VenueTagsAutocomplete'
import ImagePicker from '@/pages/App/Events/dialogs/ImagePicker.vue'
import moment from 'moment'
import notifications from '@/libs/notifications'
import rules from '@/libs/rules'
import SocialNetworksPicker from '@/pages/App/Events/dialogs/SocialNetworksPicker.vue'
import TicketPicker from '@/pages/App/Events/dialogs/TicketPicker.vue'
import transTypes from '@/libs/events/eventsTypes'
import transCategories from '@/libs/events/eventsCategories'
import timeZones from '@/libs/timeZones'

export default {
  created () {
    this.$store.dispatch('getPlaces')
    this.$store.dispatch('getEventCategories')
    this.$store.commit('SET_PAGINATION_EVENT_PREFERENCES', {
      page: 1,
      itemsPerPage: 100
    })
    this.$store.dispatch('getEventPreferences')
    this.$store.commit('SET_PAGINATION_EVENT_PREFERENCES', {})
  },
  components: { ContactsPicker, DateTimePicker, VenueTagsAutocomplete, ImagePicker, SocialNetworksPicker, TicketPicker },
  computed: {
    ...mapState({
      places: state => state.events.places,
      eventCategories: state => state.events.eventCategories,
      eventPreferences: state => state.events.eventPreferences
    }),
    types () { return transTypes() },
    categories () { return transCategories() }
  },
  data () {
    return {
      descriptionTab: 0,
      event: {
        categories: [],
        preferences: [],
        currency: '',
        timeZone: {},
        title: '',
        shortDescription: '',
        hasEventUrl: false,
        eventUrl: '',
        longDescription: '',
        starts: '',
        ends: '',
        place: '',
        limitByDocument: '',
        location: {
          type: 'Point',
          coordinates: ['', '']
        },
        note: '',
        emailNote: '',
        planner: '',
        eventRating: 0,
        priceRating: 0,
        businessFee: 0,
        tags: [],
        socialLinks: [],
        contacts: [],
        coverImage: '',
        images: [],
        type: '',
        category: '',
        tickets: [],
        ePaycoPublicKey: '',
        ePaycoPrivateKey: '',
        ePaycoTest: false,
        placeId: ''
      },
      loading: false,
      loadingEvent: false,
      menuEnds: false,
      menuStarts: false,
      valid: true,
      placesSelector: true,
      rules,
      timeZones
    }
  },
  methods: {
    showPlacesSelector () {
      if (this.placesSelector) {
        this.event.placeId = undefined
      } else {
        this.event.place = ''
        this.event.location.coordinates[0] = null
        this.event.location.coordinates[1] = null
      }

      this.placesSelector = !this.placesSelector
    },
    submit () {
      if (!this.$refs.newEditEventForm.validate()) return

      if (!this.selectedEvent) {
        this.createEvent()
      } else {
        this.editEvent()
      }
    },
    blurEmailHtmlHandler (event) {
      this.setHtml(event)
    },
    createEvent () {
      this.loading = true

      this.$store.dispatch('createEvent', Object.assign(this.event)).then(() => {
        try {
          this.$store.dispatch('updateVenuesTags')
        } catch (error) {
          console.error(error)
        }
        this.resetEvent()
        this.$emit('input', false)
        this.loading = false
        notifications.success(this.$t('general.eventCreated'))
      }).catch(error => {
        this.loading = false
        notifications.error(error.message)
      })
    },
    editEvent () {
      this.loading = true

      const data = {
        eventId: this.selectedEvent,
        category: this.event.category,
        contacts: this.event.contacts,
        currency: this.event.currency,
        timeZone: this.event.timeZone,
        ends: this.event.ends,
        eventUrl: this.event.eventUrl,
        hasEventUrl: this.event.hasEventUrl,
        coverImage: this.event.coverImage,
        images: this.event.images,
        limitByDocument: this.event.limitByDocument,
        location: this.event.location,
        longDescription: this.event.longDescription,
        note: this.event.note,
        emailNote: this.event.emailNote,
        place: this.event.place,
        planner: this.event.planner,
        eventRating: this.event.eventRating,
        priceRating: this.event.priceRating,
        businessFee: this.event.businessFee,
        tags: this.event.tags,
        shortDescription: this.event.shortDescription,
        socialLinks: this.event.socialLinks,
        starts: this.event.starts,
        tickets: this.event.tickets,
        title: this.event.title,
        type: this.event.type,
        ePaycoPublicKey: this.event.ePaycoPublicKey,
        ePaycoPrivateKey: this.event.ePaycoPrivateKey,
        ePaycoTest: this.event.ePaycoTest,
        placeId: this.event.placeId,
        categories: this.event.categories,
        preferences: this.event.preferences
      }

      this.$store.dispatch('updateEvent', data).then(() => {
        notifications.success(this.$t('general.eventModified'))
        this.resetEvent()
        this.loading = false
        try {
          this.$store.dispatch('updateVenuesTags')
        } catch (error) {
          console.error(error)
        }
        this.$emit('input', false)
      }).catch(error => {
        this.loading = false
        notifications.error(error.message)
      })
    },
    minDate () {
      return new Date().toISOString().substr(0, 10)
    },
    minDateUntil (date) {
      if (date) {
        return moment(date).format('YYYY-MM-DD')
      }
    },
    cancelNew () {
      this.resetEvent()
      this.$emit('input', false)
    },
    deleteEvent () {
      this.$emit('input', false)
    },
    resetEvent () {
      this.event = {
        currency: '',
        timeZone: {},
        title: '',
        shortDescription: '',
        longDescription: '',
        starts: '',
        ends: '',
        place: '',
        limitByDocument: '',
        location: {
          type: 'Point',
          coordinates: ['', '']
        },
        note: '',
        planner: '',
        socialLinks: [],
        contacts: [],
        coverImage: '',
        images: [],
        type: '',
        category: '',
        tickets: [],
        ePaycoPublicKey: '',
        ePaycoPrivateKey: '',
        ePaycoTest: false,
        placeId: ''
      }
    },
    setHtml (data) {
      this.event.longDescription = data.srcElement.innerText
    },
    toggleModal (value) {
      this.resetEvent()
      this.$emit('input', value)
    }
  },
  props: ['selectedEvent', 'value'],
  watch: {
    selectedEvent (value) {
      if (value) {
        this.loadingEvent = true
        this.$store.dispatch('getEvent', { eventId: value }).then(response => {
          this.loadingEvent = false
          this.editingEvent = true
          const keys = Object.keys(response)
          if (response.contacts) {
            for (let i = 0; i < response.contacts.length; i++) {
              const contact = response.contacts[i]
              if (typeof contact.phone === 'string') {
                contact.phone = {
                  code: 'co',
                  country: 'colombia',
                  number: '57',
                  phone: contact.phone,
                  valid: true
                }
              }
            }
          }
          keys.forEach(item => {
            this.$set(this.event, item, response[item])
          })
        }).catch(error => {
          this.loadingEvent = false
          console.log(error)
        })
      } else {
        this.resetEvent()
      }
    }
  }
}
</script>
